import styled from "styled-components";

export const LibraryFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;
